export default "__VITE_ASSET__FIiN1WhB__"